export const apiConfig = {
  baseUrl: "https://api.github.com/graphql",
  apiKey: process.env.REACT_APP_GH_API_KEY,
};
